import React, { useState, useMemo } from 'react';
import workExperience from '../assets/data/workExperience';
import TimelineStyles from './TimelineStyles';
import { FaAngleDoubleUp, FaAngleDoubleDown } from "react-icons/fa";

const TimelineItem = React.memo(({ experience, index }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div
        className={`timelineContainer timeline-item ${
          index % 2 === 0 ? 'left' : 'right'
        }`}
      >
        <div className="timeline-card">
          <div
            className={`accordion-header${isOpen ? ' open' : ''}`}
            onClick={() => setIsOpen(!isOpen)}
            role="button"
            tabIndex={0}
            aria-expanded={isOpen}
            aria-controls={`accordion-body-${index}`}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setIsOpen(!isOpen)}
          >
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
              <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                <div className="card-header">
                  <h4>{experience.company}</h4>
                  <h5>{experience.role}</h5>
                  <h6>{experience.date}</h6>
                </div>
              </div>
              <div className="accordion-fab" style={{ flexShrink: 0 }}>
                <div className="fab-icon">
                  {isOpen ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />}
                </div>
              </div>
            </div>
          </div>
          <div
            id={`accordion-body-${index}`}
            className="accordion-body"
            style={{ display: isOpen ? 'block' : 'none' }}
          >
              <div className="card-body">
                {experience.projects && experience.projects.length > 0 ? (
                  experience.projects.map((proj, pIdx) => (
                    <div key={pIdx} className="sub-project">
                      <h6 className="sub-project__name">{proj.name}</h6>
                      <ul>
                        {proj.details.map((item, idx) => (
                          <li key={idx}>{item}</li>
                        ))}
                      </ul>
                      {proj.technologies && (
                        <p className="sub-project__tech">{proj.technologies}</p>
                      )}
                    </div>
                  ))
                ) : (
                  <>
                    {experience.project && (
                      <h6 className="single-project__name">Project: {experience.project}</h6>
                    )}
                    <h6>Responsibilities:</h6>
                    <ul>
                      {experience.responsibilities && experience.responsibilities.length > 0
                        ? experience.responsibilities.map((item, idx) => (
                            <li key={idx}>{item}</li>
                          ))
                        : <li>—</li>}
                    </ul>
                  </>
                )}
              </div>
              {experience.technologies && experience.technologies.length > 0 && (
                <div className="card-footer">
                  <h6>Technologies Used:</h6>
                  <p>{experience.technologies.join(', ')}</p>
                </div>
              )}
            </div>
        </div>
      </div>
    </div>
  );
});

export default function Timeline() {
  const experiences = useMemo(() => workExperience, []);

  if (!experiences || experiences.length === 0) {
    return <div>No work experience data available</div>;
  }

  return (
    <TimelineStyles>
      <div className="padding" id="technical-skills-section">
        <div className="container-fluid work-experience-text">
          <div className="row">
            <div className="col">
              <h3 className="about__info__heading">WORK EXPERIENCE</h3>
            </div>
          </div>
          <div className="timeline">
            <div>
              {experiences.map((experience, index) => (
                <TimelineItem key={index} experience={experience} index={index} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </TimelineStyles>
  );
}
